/* Moved out of snippets/pp-cart-drawer-shell.liquid on 2026-10-03 so it is cached across pages (was inline on every page). Runs deferred; nothing calls it before the page has loaded. */
/* ppUndo (2026-10-04): removing a basket line is instant and offers "Undo" for 8s instead of an "Are you sure?" box
   (Apple HIG: no alerts for common, undoable actions; Baymard/NN/g: prefer undo). snapshot() keeps the exact line —
   variant, quantity and every Globo property — plus any separate frame add-on line linked to it, so restore() puts back
   the same print at the same price. Used by the slide-out basket below and by the cart page (main-cart-items). */
window.ppUndo = window.ppUndo || (function () {
  var last = null, timer = null;
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var clean = function (p) { var o = {}; Object.keys(p || {}).forEach(function (k) { if (p[k] != null && p[k] !== '') o[k] = p[k]; }); return o; };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
  return {
    fromCart: function (cart, key) {
      var it = (cart.items || []).filter(function (i) { return i.key === key; })[0];
      if (!it) return null;
      var pg = it.properties && it.properties._gpo_product_group;
      return {
        title: String(it.product_title || it.title || 'Poster').split(' by ')[0],
        line: { id: it.variant_id, quantity: it.quantity, properties: clean(it.properties) },
        pg: pg || null,
        adds: pg ? cart.items.filter(function (i) { return i.properties && i.properties._gpo_parent_product_group === pg; })
          .map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: clean(i.properties) }; }) : []
      };
    },
    snapshot: function (key) {
      var self = this;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { return self.fromCart(c, key); }).catch(function () { return null; });
    },
    restore: function () {
      var s = last; last = null; clearTimeout(timer);
      if (!s) return Promise.resolve();
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var items = [s.line];
        // A frame add-on line that was removed with the poster comes back too; one still in the basket is left alone.
        var still = s.pg && c.items.some(function (i) { return i.properties && i.properties._gpo_parent_product_group === s.pg; });
        if (!still) items = items.concat(s.adds);
        return fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: items }) });
      }).catch(function () {});
    },
    // Puts "Removed <title> · Undo" at the top of `host`. Buttons carry data-pp-cd-undo (the basket's own click handler
    // restores); the cart page wires its own.
    show: function (host, snap) {
      last = snap; clearTimeout(timer);
      if (!host) return;
      var old = host.querySelector('.pp-undo'); if (old) old.remove();
      var el = document.createElement('div');
      el.className = 'pp-undo'; el.setAttribute('role', 'status');
      el.innerHTML = '<span>Removed <b>' + esc(snap.title) + '</b></span><button type="button" class="pp-undo__btn" data-pp-cd-undo>Undo</button>';
      host.insertBefore(el, host.firstChild);
      timer = setTimeout(function () { last = null; el.remove(); }, 8000);
    }
  };
})();
  (function () {
    if (window.ppCartDrawer) return;
    var root = document.querySelector('[data-pp-cd]');
    if (!root) return;
    var enabled = function () { return !(window.ppPreview && window.ppPreview.has('nodrawer')); };
    var body = root.querySelector('[data-pp-cd-body]'), panel = root.querySelector('.pp-cd__panel');
    var lastFocus = null, seq = 0;

    var setCount = function (cart) {
      var n = cart.items.reduce(function (t, i) { return t + (i.properties && i.properties._gpo_parent_product_group ? 0 : i.quantity); }, 0);
      document.querySelectorAll('.pp-header__cart-count').forEach(function (el) { el.textContent = n; });
      var link = document.querySelector('.pp-header__cart');
      if (link && n && !link.querySelector('.pp-header__cart-count')) {
        var s = document.createElement('span'); s.className = 'pp-header__cart-count'; s.textContent = n; link.appendChild(s);
      }
    };
    var ship = function () {
      var el = body.querySelector('[data-pp-free-ship]');
      if (!el || !window.ppRegion) return;
      var r = window.ppRegion.get();
      if (window.ppRegion.free(r)) { el.textContent = 'Free tracked delivery to ' + window.ppRegion.name(r); el.hidden = false; }
    };
    // ---- Preview basket2: rotate the real review quotes, and show the live dispatch countdown.
    var qTimer = null;
    var quotes = function () {
      if (qTimer) { clearInterval(qTimer); qTimer = null; }
      var qs = body.querySelectorAll('[data-pp-cd-quote]'); if (qs.length < 2) return;
      var i = 0;
      qTimer = setInterval(function () {
        if (!root.classList.contains('is-open')) return;
        qs[i].classList.remove('is-on'); i = (i + 1) % qs.length; qs[i].classList.add('is-on');
      }, 5000);
    };
    // Same rules as snippets/pp-delivery-estimate.liquid (keep in step): Mon–Fri before 1pm UK = dispatched today;
    // non-UK regions add one working day; delivery = dispatch + region's working-day range; UK bank holidays skipped.
    var ETA = { cutoff: 13, holidays: '2026-12-25 2026-12-28 2027-01-01 2027-03-26 2027-03-29 2027-05-03 2027-05-31 2027-08-30 2027-12-27 2027-12-28',
      r: { gb: [2, 4, 0], us: [2, 4, 1], ca: [3, 5, 1], au: [2, 5, 1], eu: [3, 5, 1], row: [7, 10, 1] } };
    var etaTimer = null;
    var eta = function () {
      if (etaTimer) { clearInterval(etaTimer); etaTimer = null; }
      var el = body.querySelector('[data-pp-cd-eta]'); if (!el) return;
      var H = {}; ETA.holidays.split(' ').forEach(function (d) { H[d] = 1; });
      var iso = function (d) { return d.toISOString().slice(0, 10); };
      var add = function (d, n) { return new Date(d.getTime() + n * 864e5); };
      var work = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !H[iso(d)]; };
      var next = function (d) { do { d = add(d, 1); } while (!work(d)); return d; };
      var addW = function (d, n) { for (var i = 0; i < n; i++) d = next(d); return d; };
      var fmtP = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      var dFmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
      var wFmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long' });
      var f = function (d) { return dFmt.format(d).replace(',', ''); };
      var render = function () {
        var now = Date.now(), p = {};
        fmtP.formatToParts(new Date(now)).forEach(function (x) { p[x.type] = x.value; });
        var h = +p.hour % 24, today = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
        var offset = Date.UTC(+p.year, +p.month - 1, +p.day, h, +p.minute) - Math.floor(now / 60000) * 60000;
        var cut = (work(today) && h < ETA.cutoff) ? today : next(today);
        var cutMs = Date.UTC(cut.getUTCFullYear(), cut.getUTCMonth(), cut.getUTCDate(), ETA.cutoff) - offset;
        var reg = (window.ppRegion && window.ppRegion.get && window.ppRegion.get()) || 'gb';
        var R = ETA.r[reg] || ETA.r.gb;
        var disp = addW(cut, R[2]), from = addW(disp, R[0]), to = addW(disp, R[1]);
        var arrive = from.getUTCMonth() === to.getUTCMonth() ? f(from).replace(/\s\S+$/, '') + ' – ' + f(to) : f(from) + ' – ' + f(to);
        var left = Math.max(0, Math.floor((cutMs - now) / 60000));
        var dWord = iso(disp) === iso(today) ? 'today' : iso(disp) === iso(add(today, 1)) ? 'tomorrow' : wFmt.format(disp);
        var lead = left < 1440
          ? 'Order within <b>' + Math.floor(left / 60) + 'h ' + (left % 60) + 'm</b> for dispatch ' + dWord
          : 'Order by <b>1pm ' + wFmt.format(cut) + '</b> for dispatch ' + (iso(disp) === iso(cut) ? 'that day' : dWord);
        el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
          + '<span>' + lead + ' &middot; arrives <b>' + arrive + '</b></span>';
        el.hidden = false;
      };
      render(); etaTimer = setInterval(render, 30000);
    };
    var ensureFrameUpgrade = function () {
      if (window.__ppFrameUpgrade) return;
      var t = document.getElementById('pp-fu-tpl'); if (!t) return;
      var frag = t.content.cloneNode(true);
      frag.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script'); if (old.src) s.src = old.src; else s.textContent = old.textContent; old.parentNode.replaceChild(s, old);
      });
      document.body.appendChild(frag);
    };
    var load = function (added) {
      var my = ++seq;
      ensureFrameUpgrade();
      body.classList.add('is-busy');
      return fetch('/?sections=pp-cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (my !== seq) return;
          var tmp = document.createElement('div'); tmp.innerHTML = j['pp-cart-drawer'] || '';
          var inner = tmp.querySelector('.shopify-section') || tmp;
          body.innerHTML = inner.innerHTML;
          if (added) { var t = body.querySelector('[data-pp-cd-title]'); if (t) { t.classList.add('is-added'); t.firstChild.nodeValue = 'Added to your basket '; } }
          ship(); quotes(); eta();
        })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(setCount); })
        .catch(function () {})
        .then(function () { body.classList.remove('is-busy'); });
    };
    var open = function (added) {
      lastFocus = document.activeElement;
      root.hidden = false; void root.offsetWidth; root.classList.add('is-open');
      document.documentElement.classList.add('pp-cd-lock');
      panel.focus({ preventScroll: true });
      return load(added);
    };
    var close = function () {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('pp-cd-lock');
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    };
    window.ppCartDrawer = { open: open, close: close, enabled: enabled };

    // --- Product page form: runs after Globo (bubbling, document level), only if the submit wasn't cancelled.
    document.addEventListener('submit', function (e) {
      if (!enabled() || e.defaultPrevented) return;
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-pp-form]')) return;
      e.preventDefault();
      var btns = document.querySelectorAll('[data-pp-atc], [data-pp-sticky-atc]');
      btns.forEach(function (b) { b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (added) {
          // "Bundle & save" (preview basket2, snippets/pp-pdp-bundle.liquid): the two extra prints copy this line's
          // size / frame / colour exactly like the basket's quick adds. A failure here keeps the main print added.
          var bx = !(window.ppPreview && window.ppPreview.has('nobasket2')) && form.querySelector('[data-pp-bundle-pick]:checked');
          var ids = bx && bx.value === 'bundle' ? (window.ppBundleIds ? window.ppBundleIds() : []) : [];
          if (!ids.length || !added || !added.key) return open(true);
          return build(ids, added.key, true)
            .then(function (items) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
            .catch(function () {})
            .then(function () { return open(true); });
        })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); })
        .then(function () { btns.forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }); });
    });

    // --- Inside the drawer: close, remove, quick add.
    var groupSeq = 0;
    var build = function (ids, seedKey, clone) {
      if (!clone || !seedKey) return Promise.resolve(ids.map(function (id) { return { id: +id, quantity: 1 }; }));
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var seed = cart.items.filter(function (i) { return i.key === seedKey; })[0];
        var sp = (seed && seed.properties) || {};
        var pg0 = sp._gpo_product_group;
        var addons = pg0 ? cart.items.filter(function (i) { return i.properties && i.properties._gpo_parent_product_group === pg0; }) : [];
        var items = [];
        ids.forEach(function (id) {
          var pg = String(Date.now()) + (groupSeq++);
          var props = {};
          Object.keys(sp).forEach(function (k) { if (k !== '_set' && k !== 'Gift note' && sp[k] != null && sp[k] !== '') props[k] = sp[k]; });
          if (pg0) props._gpo_product_group = pg;
          items.push({ id: +id, quantity: 1, properties: props });
          addons.forEach(function (a) { items.push({ id: a.variant_id, quantity: 1, properties: { _gpo_parent_product_group: pg, _gpo_field_name: a.properties._gpo_field_name } }); });
        });
        return items;
      });
    };
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pp-cd-close]')) { e.preventDefault(); close(); return; }
      var un = e.target.closest('[data-pp-cd-undo]');
      if (un) {
        e.preventDefault(); un.disabled = true; un.textContent = 'Restoring…';
        ppUndo.restore().then(function () { return load(false); });
        return;
      }
      var rm = e.target.closest('[data-pp-cd-remove]');
      if (rm) {
        e.preventDefault(); body.classList.add('is-busy');
        var key = rm.getAttribute('data-pp-cd-remove'), snap = null;
        // Undo, not "Are you sure?" (Apple HIG / Baymard): remember the exact line first, then remove it at once.
        ppUndo.snapshot(key)
          .then(function (s) { snap = s; return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); })
          .then(function () { return load(false); })
          .then(function () { if (snap) ppUndo.show(body.querySelector('.pp-cd__scroll, .pp-cd__empty') || body, snap); });
        return;
      }
      var b = e.target.closest('[data-pp-cd-add]');
      if (!b) return;
      e.preventDefault(); b.classList.add('is-busy'); b.textContent = b.textContent.trim() === '+' ? '…' : 'Adding…';
      var sec = b.closest('[data-pp-cd-seed]');
      build(b.getAttribute('data-pp-cd-add').split(','), sec && sec.getAttribute('data-pp-cd-seed'), b.hasAttribute('data-pp-cd-clone'))
        .then(function (items) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { if (!r.ok) throw r; return load(true); })
        .catch(function () { window.location.href = b.getAttribute('data-href') || '/cart'; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open') && !document.querySelector('dialog[open]')) close(); });
  })();
